
(function () {
  'use strict';

  /* search toggle */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hasAttribute('hidden');
      if (open) { searchPanel.removeAttribute('hidden'); } else { searchPanel.setAttribute('hidden', ''); }
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) { var f = searchPanel.querySelector('input'); if (f) f.focus(); }
    });
  }

  /* mobile submenu toggles */
  document.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (window.innerWidth > 749) return;
      e.preventDefault();
      var item = btn.closest('.hdr-item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* pdp thumbnails */
  var mainImg = document.getElementById('PdpMainImage');
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-thumb');
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* quantity stepper */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10);
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* variant selection */
  var variantScript = document.querySelector('[data-variant-json]');
  if (variantScript) {
    var variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch (e) { variants = []; }

    var form = document.getElementById('ProductForm');
    var variantInput = document.querySelector('[data-variant-input]');
    var addBtn = document.querySelector('[data-add-btn]');
    var priceEl = document.querySelector('[data-price]');
    var lowStockEl = document.querySelector('[data-low-stock]');

    function selectedOptions() {
      var out = [];
      document.querySelectorAll('.pdp-option').forEach(function (group) {
        var checked = group.querySelector('input[data-option-selector]:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function refresh() {
      var v = matchVariant(selectedOptions());

      document.querySelectorAll('.pdp-chip').forEach(function (chip) {
        var input = chip.querySelector('input');
        chip.classList.toggle('is-selected', !!(input && input.checked));
      });

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (priceEl) {
        var html = '<span class="pdp-price-now">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="pdp-price-was">' + formatMoney(v.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (lowStockEl) {
        if (v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 15) {
          lowStockEl.textContent = 'Low stock: ' + v.inventory_quantity + ' left';
          lowStockEl.style.display = '';
        } else {
          lowStockEl.style.display = 'none';
        }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    document.querySelectorAll('input[data-option-selector]').forEach(function (input) {
      input.addEventListener('change', refresh);
    });
    if (form) refresh();
  }

  /* video carousel */
  document.querySelectorAll('[data-video-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-vc-track]');
    var slides = root.querySelectorAll('[data-vc-slide]');
    var dots = root.querySelectorAll('[data-vc-dot]');
    if (!track || slides.length === 0) return;
    var index = 0;

    function go(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-vc-dot'), 10)); });
    });

    root.querySelectorAll('[data-vc-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var frame = btn.closest('[data-vc-embed]');
        if (!frame) return;
        var id = frame.getAttribute('data-vc-embed');
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1');
        iframe.setAttribute('title', 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        frame.innerHTML = '';
        frame.appendChild(iframe);
      });
    });

    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) go(dx < 0 ? index + 1 : index - 1);
      startX = null;
    });

    go(0);
  });
})();
